<template>
  <el-dialog title="用户登录" :visible.sync="dialogFormVisible" style="width: 1000px;"  :style="{transform: `scale(${width / ($isPhone ? 600 : 1920)})`, marginLeft: $isPhone ? '-300px' : '480px'}" center  :append-to-body="true">
    <el-form :model="loginForm" ref="loginForm" :rules="loginRules">
      <el-form-item label="账号" prop="account" :label-width="formLabelWidth">
        <el-input v-model="loginForm.account" autocomplete="off" style="width: 278px;" size="mini"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password" :label-width="formLabelWidth">
        <el-input v-model="loginForm.password" autocomplete="off" show-password style="width: 278px;" size="mini"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <div class="custom-btn reg" @click="dialogFormVisible = false">取消</div>
      <div class="custom-btn login" @click="handleLogin">确认</div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { encryptAccount } from '@/utils'
export default {
  data () {
    return {
      dialogFormVisible: false,
      loginForm: {
        account: '',
        password: ''
      },
      loginRules: {
        account: [{ required: true, trigger: 'blur', message: '请输入账号名称' }],
        password: [{ required: true, trigger: 'blur', message: '请输入密码' }]
      },
      formLabelWidth: '120px',
      width: window.innerWidth,
      transform: '',
      toPath: null,
      toUrl: null
    }
  },
  computed: {
    ...mapGetters(['menuList', 'userInfo'])
  },
  methods: {
    open () {
        this.dialogFormVisible = true
    },
    resize () {
      let width = window.innerWidth
      this.transform = `scale(${width / (this.$isPhone ? 1080 : 1920)})`
    },
    handleLogin () {
      // this.$message.error(this.loginForm.password)
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.$store.dispatch('login', {
            data: encryptAccount({
              account: this.loginForm.account,
              password: this.loginForm.password
            })
          }).then((res) => {
            this.next()
            this.$message.success('登录成功!')
            this.dialogFormVisible = false
          }).catch((res) => {
            this.$message.error('登录错误')
            this.toPath = null
            this.toUrl = null
          })
        } else {
          return false
        }
        return false
      })
    },
    next () {
      if (this.toPath) this.$router.push({ path: this.toPath })
      if (this.toUrl) window.open(this.toUrl)
      this.toPath = null
      this.toUrl = null
    }
  },
  mounted () {
    this.$bus.$on('openLogin', obj => {
      this.toPath = obj.path
      this.toUrl = obj.url
      this.next()
      // if (getToken()) {
      //   this.next()
      // } else {
      //   this.open()
      // }
    })
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
/deep/ .el-dialog {
  background-image: url("~@/assets/images/login-bg.png");
  background-size: 100% 100%;
}
/deep/ .el-form-item__label {
  font-family: "FangZhengKaiTi-GBK";
}
.custom-btn {
  width: 198px;
  height: 45px;
  line-height: 45px;
  font-family: "FangZhengKaiTi-GBK";
  .font-size-medium;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  &:hover {
    opacity: 0.9;
  }
}
.reg {
  background: #F5F2EB;
  color: #4D1A19;
  border: 2px solid #4D1A19;
}
.login {
  background: #4D1A19;
  color: white;
  margin-left: 58px;
}
</style>
